import type { 
  GetToolsBetPromoCodesCheckerOverallStatsData,
  GetToolsBetPromoCodesCheckerOverallStatsResponse,

  GetToolsBetPromoCodesCheckerPlayersStatsData,
  GetToolsBetPromoCodesCheckerPlayersStatsResponse,

  PostToolsBetPromoCodesCheckerUploadPromoCodesData,
  PostToolsBetPromoCodesCheckerUploadPromoCodesResponse,

  GetToolsPromoMatchesLeaguesCountData,
  GetToolsPromoMatchesLeaguesCountResponse,

  GetToolsPromoMatchesLeaguesData,
  GetToolsPromoMatchesLeaguesResponse,

  GetToolsPromoMatchesMatchesCountData,
  GetToolsPromoMatchesMatchesCountResponse,

  GetToolsPromoMatchesMatchesData,
  GetToolsPromoMatchesMatchesResponse,

  GetToolsPromoMatchesTeamsCountData,
  GetToolsPromoMatchesTeamsCountResponse,

  GetToolsPromoMatchesTeamsData,
  GetToolsPromoMatchesTeamsResponse,

  GetToolsPromoMatchesMatchesByIdData,
  GetToolsPromoMatchesMatchesByIdResponse,

  DeleteToolsPromoMatchesMatchesByIdData,
  DeleteToolsPromoMatchesMatchesByIdResponse,
  
  PutToolsPromoMatchesMatchesByIdData,
  PutToolsPromoMatchesMatchesByIdResponse,

  PostToolsPromoMatchesMatchesData,
  PostToolsPromoMatchesMatchesResponse
} from "@/types/openapi-ts";

import type { AxiosInstance } from "axios";

export function getToolsApiModule(affiliatesApi: AxiosInstance) {
  return {
    // promo checker
    getPromoCheckerOverallStats(params: GetToolsBetPromoCodesCheckerOverallStatsData['query']) {
      return affiliatesApi.get<GetToolsBetPromoCodesCheckerOverallStatsResponse>(
        '/tools/bet-promo-codes-checker/overall-stats',
        { params }
      );
    },
    getPromoCheckerPlayersStats(params: GetToolsBetPromoCodesCheckerPlayersStatsData['query']) {
      return affiliatesApi.get<GetToolsBetPromoCodesCheckerPlayersStatsResponse>(
        '/tools/bet-promo-codes-checker/players-stats',
        { params }
      );
    },
    promoCheckerUploadCodes(payload: PostToolsBetPromoCodesCheckerUploadPromoCodesData['query']) {
      return affiliatesApi.post<PostToolsBetPromoCodesCheckerUploadPromoCodesResponse>(
        '/tools/bet-promo-codes-checker/upload-promo-codes', 
        payload
      );
    },

    // landing leagues
    getLeaguesCount() {
      return affiliatesApi.get<GetToolsPromoMatchesLeaguesCountResponse>('/tools/promo-matches/leagues/count');
    },
    getLeagues(params: GetToolsPromoMatchesLeaguesData['query']) {
      return affiliatesApi.get<GetToolsPromoMatchesLeaguesResponse>('/tools/promo-matches/leagues', { params });
    },
    getMatchesCount(params: GetToolsPromoMatchesMatchesCountData) {
      return affiliatesApi.get<GetToolsPromoMatchesMatchesCountResponse>('/tools/promo-matches/matches/count', { params });
    },
    getMatches(params: GetToolsPromoMatchesMatchesData['query']) {
      return affiliatesApi.get<GetToolsPromoMatchesMatchesResponse>('/tools/promo-matches/matches', { params });
    },
    getTeamsCount(params: GetToolsPromoMatchesTeamsCountData['query']) {
      return affiliatesApi.get<GetToolsPromoMatchesTeamsCountResponse>('/tools/promo-matches/teams/count', { params });
    },
    getTeams(params: GetToolsPromoMatchesTeamsData['query']) {
      return affiliatesApi.get<GetToolsPromoMatchesTeamsResponse>('/tools/promo-matches/teams', { params });
    },
    getMatch(id: string) {
      return affiliatesApi.get<GetToolsPromoMatchesMatchesByIdResponse>(`/tools/promo-matches/matches/${id}`);
    },
    deleteMatch(id: string) {
      return affiliatesApi.delete<DeleteToolsPromoMatchesMatchesByIdResponse>(`/tools/promo-matches/matches/${id}`);
    },
    updateMatch(id: string, data: PutToolsPromoMatchesMatchesByIdData['body']) {
      return affiliatesApi.put<PutToolsPromoMatchesMatchesByIdResponse>(`/tools/promo-matches/matches/${id}`, data);
    },
    createMatch(data: PostToolsPromoMatchesMatchesData['body']) {
      return affiliatesApi.post<PostToolsPromoMatchesMatchesResponse>('/tools/promo-matches/matches', data);
    },
  };
}
